// Auto-generated from workspace JSON (բնակավայր → string arrays).
// Source: /Users/geghamjivanyan/workspace/scripts/բնակավայրեր_ըստ_մարզի.json
export const ARMENIA_SETTLEMENTS_BY_REGION = {
  "Երևան": [
    "Երևան"
  ],
  "Արագածոտն": [
    "Ագարակ",
    "Ագարակավան",
    "Ալագյազ",
    "Ակունք",
    "Աղձք",
    "Անտառուտ",
    "Աշնակ",
    "Աշտարակ",
    "Ապարան",
    "Ավան",
    "Ավշեն",
    "Արագած",
    "Արագածավան",
    "Արագածոտն",
    "Արայի",
    "Արուճ",
    "Արտաշավան",
    "Արտենի",
    "Արևուտ",
    "Ափնագյուղ",
    "Բազմաղբյուր",
    "Բերքառատ",
    "Բյուրական",
    "Գառնահովիտ",
    "Գեղադիր",
    "Գեղաձոր",
    "Գեղարոտ",
    "Գետափ",
    "Դաշտադեմ",
    "Դավթաշեն",
    "Դդմասար",
    "Դիան",
    "Դպրեվանք",
    "Եղիպատրուշ",
    "Եղնիկ",
    "Երնջատափ",
    "Զարինջա",
    "Զովասար",
    "Թաթուլ",
    "Թալին",
    "Թթուջուր",
    "Թլիկ",
    "Իրինդ",
    "Լեռնապար",
    "Լեռնարոտ",
    "Լուսագյուղ",
    "Լուսակն",
    "Լուսաղբյուր",
    "Խնուսիկ",
    "Ծաղկահովիտ",
    "Ծաղկաշեն (Ապարան)",
    "Ծաղկասար",
    "Ծիլքար",
    "Կաթնաղբյուր",
    "Կայք",
    "Կանիաշիր",
    "Կանչ",
    "Կարբի",
    "Կարին",
    "Կարմրաշեն",
    "Կաքավաձոր",
    "Կոշ",
    "Հակո",
    "Հարթավան",
    "Հացաշեն",
    "Հնաբերդ",
    "Ձորագլուխ",
    "Ձորագյուղ",
    "Ղազարավան",
    "Ճարճակիս",
    "Մաստարա",
    "Մելիքգյուղ",
    "Մեծաձոր",
    "Միջնատուն",
    "Միրաք",
    "Մուղնի",
    "Ներքին Բազմաբերդ",
    "Ներքին Սասնաշեն",
    "Նիգավան",
    "Նիգատուն",
    "Նոր Ամանոս",
    "Նոր Արթիկ",
    "Նոր Եդեսիա",
    "Նորաշեն",
    "Շամիրամ",
    "Շենավան",
    "Շենկանի",
    "Շղարշիկ",
    "Շողակն",
    "Ոսկեթաս",
    "Ոսկեհատ",
    "Ոսկևազ",
    "Ուշի",
    "Ուջան",
    "Չքնաղ",
    "Պարտիզակ",
    "Ջամշլու",
    "Ջրամբար",
    "Ռյա թազա",
    "Սադունց",
    "Սաղմոսավան",
    "Սասունիկ",
    "Սարալանջ",
    "Սիփան",
    "Սորիկ",
    "Սուսեր",
    "Վարդաբլուր (Արագած)",
    "Վարդենիս (Արագածոտն)",
    "Վարդենուտ",
    "Վերին Բազմաբերդ",
    "Վերին Սասնաշեն",
    "Վերին Սասունիկ",
    "Տեղեր",
    "Ցամաքասար",
    "Փարպի",
    "Քուչակ",
    "Օթևան",
    "Օհանավան",
    "Օշական",
    "Օրգով"
  ],
  "Արարատ": [
    "Աբովյան",
    "Ազատաշեն",
    "Ազատավան",
    "Այգավան",
    "Այգեզարդ",
    "Այգեպատ",
    "Այգեստան",
    "Այնթապ",
    "Ավշար",
    "Արալեզ",
    "Արարատ (գյուղ)",
    "Արարատ (քաղաք)",
    "Արաքսավան",
    "Արբաթ",
    "Արգավանդ",
    "Արմաշ",
    "Արտաշատ",
    "Արևաբույր",
    "Արևշատ",
    "Բաղրամյան",
    "Բարձրաշեն",
    "Բերդիկ",
    "Բերքանուշ",
    "Բյուրավան",
    "Բուրաստան",
    "Գեղանիստ",
    "Գետազատ",
    "Գետափնյա",
    "Գինևետ",
    "Գոռավան",
    "Դալար",
    "Դաշտավան",
    "Դաշտաքար",
    "Դարակերտ",
    "Դարբնիկ",
    "Դեղձուտ",
    "Դիմիտրով",
    "Դիտակ",
    "Դվին",
    "Եղեգնավան",
    "Երասխ",
    "Զանգակատուն",
    "Զորակ",
    "Լանջազատ",
    "Լանջանիստ",
    "Լանջառ",
    "Լուսաշող",
    "Լուսառատ",
    "Խաչփառ",
    "Կանաչուտ",
    "Կաքավաբերդ",
    "Հայանիստ",
    "Հնաբերդ",
    "Հովտաշատ",
    "Հովտաշեն",
    "Ղուկասավան",
    "Մասիս",
    "Մարմարաշեն",
    "Մխչյան",
    "Մրգանուշ",
    "Մրգավան",
    "Մրգավետ",
    "Նարեկ",
    "Նիզամի",
    "Նշավան",
    "Նոյակերտ",
    "Նոր Խարբերդ",
    "Նոր Կյուրին",
    "Նոր կյանք",
    "Նոր ուղի",
    "Նորաբաց",
    "Նորամարգ",
    "Շահումյան",
    "Շաղափ",
    "Ոսկետափ",
    "Ոստան",
    "Ուրցալանջ",
    "Ուրցաձոր",
    "Պարույր Սևակ",
    "Ջրահովիտ",
    "Ջրաշեն",
    "Ռանչպար",
    "Սայաթ-Նովա",
    "Սիս",
    "Սիսավան",
    "Սիփանիկ",
    "Սուրենավան",
    "Վանաշեն",
    "Վարդաշատ",
    "Վարդաշեն",
    "Վեդի",
    "Վերին Արտաշատ",
    "Վերին Դվին",
    "Տափերական",
    "Տիգրանաշեն",
    "Փոքր Վեդի",
    "Քաղցրաշեն"
  ],
  "Արմավիր": [
    "Ալաշկերտ",
    "Ակնալիճ",
    "Ակնաշեն",
    "Աղավնատուն",
    "Ամասիա",
    "Ամբերդ",
    "Այգեկ",
    "Այգեշատ",
    "Այգևան",
    "Ապագա",
    "Առատաշեն",
    "Արագած",
    "Արազափ",
    "Արաքս",
    "Արգավանդ",
    "Արգինա",
    "Արմավիր",
    "Արմավիր (քաղաք)",
    "Արշալույս",
    "Արտամետ",
    "Արտաշար",
    "Արտիմետ",
    "Արևադաշտ",
    "Արևաշատ",
    "Արևիկ",
    "Բագարան",
    "Բաղրամյան",
    "Բամբակաշատ",
    "Բերքաշատ",
    "Գայ",
    "Գեղակերտ",
    "Գետաշեն",
    "Գրիբոյեդով",
    "Դալարիկ",
    "Դաշտ",
    "Դողս",
    "Եղեգնուտ",
    "Երասխահուն",
    "Երվանդաշատ",
    "Զարթոնք",
    "Թաիրով",
    "Լենուղի",
    "Լեռնագոգ",
    "Լեռնամերձ",
    "Լուկաշին",
    "Լուսագյուղ",
    "Խանջյան",
    "Խորոնք",
    "Ծաղկալանջ",
    "Ծաղկունք",
    "Ծիածան",
    "Կողբավան",
    "Հայթաղ",
    "Հայկաշեն",
    "Հայկավան",
    "Հացիկ",
    "Հովտամեջ",
    "Հուշակերտ",
    "Մայիսյան",
    "Մարգարա",
    "Մեծամոր",
    "Մեծամոր (քաղաք)",
    "Մերձավան",
    "Մյասնիկյան",
    "Մուսալեռ",
    "Մրգաշատ",
    "Մրգաստան",
    "Նալբանդյան",
    "Նոր Արմավիր",
    "Նոր Արտագերս",
    "Նոր Կեսարիա",
    "Նորակերտ",
    "Նորապատ",
    "Նորավան",
    "Շահումյան",
    "Շահումյանի թռչնաֆաբրիկա",
    "Շենավան",
    "Շենիկ",
    "Ոսկեհատ",
    "Պտղունք",
    "Ջանֆիդա",
    "Ջրաշեն",
    "Ջրառատ",
    "Ջրարբի",
    "Սարդարապատ",
    "Վաղարշապատ",
    "Վանանդ",
    "Վարդանաշեն",
    "Տալվորիկ",
    "Տանձուտ",
    "Տարոնիկ",
    "Փարաքար",
    "Փշատավան",
    "Քարակերտ",
    "Ֆերիկ"
  ],
  "Գեղարքունիք": [
    "Ազատ",
    "Ախպրաձոր",
    "Ակունք",
    "Աղբերք",
    "Այգուտ",
    "Այրք",
    "Անտառամեջ",
    "Աստղաձոր",
    "Ավազան",
    "Արեգունի",
    "Արծվանիստ",
    "Արծվաշեն",
    "Արտանիշ",
    "Արփունք",
    "Բարեպատ",
    "Բերդկունք",
    "Գագարին",
    "Գանձակ",
    "Գավառ",
    "Գեղամաբակ",
    "Գեղամասար",
    "Գեղամավան",
    "Գեղարքունիք",
    "Գեղաքար",
    "Գեղհովիտ",
    "Գետիկ",
    "Դարանակ",
    "Դդմաշեն",
    "Դպրաբակ",
    "Դրախտիկ",
    "Երանոս",
    "Զառիվեր",
    "Զոլաքար",
    "Զովաբեր",
    "Թթուջուր",
    "Լանջաղբյուր",
    "Լեռնահովիտ",
    "Լիճք",
    "Լճաշեն",
    "Լճավան",
    "Լճափ",
    "Լուսակունք",
    "Խաչաղբյուր",
    "Ծակքար",
    "Ծաղկաշեն (Գավառ)",
    "Ծաղկունք",
    "Ծափաթաղ",
    "Ծովագյուղ",
    "Ծովազարդ",
    "Ծովակ",
    "Ծովասար",
    "Ծովինար",
    "Կալավան",
    "Կախակն",
    "Կարճաղբյուր",
    "Կարմիրգյուղ",
    "Կութ",
    "Կուտական",
    "Հայրավանք",
    "Ձորագյուղ",
    "Ձորավանք",
    "Ճամբարակ",
    "Ճապկուտ",
    "Մադինա",
    "Մարտունի",
    "Մարտունի (քաղաք)",
    "Մաքենիս",
    "Մեծ Մասրիկ",
    "Ներքին Գետաշեն",
    "Ներքին Շորժա",
    "Նշխարք",
    "Նորաբակ",
    "Նորակերտ",
    "Նորաշեն",
    "Նորատուս",
    "Շատջրեք",
    "Շատվան",
    "Շորժա",
    "Չկալովկա",
    "Ջաղացաձոր",
    "Ջիլ",
    "Սարուխան",
    "Սեմյոնովկա",
    "Սոթք",
    "Սևան",
    "Վահան",
    "Վաղաշեն",
    "Վանևան",
    "Վարդաձոր",
    "Վարդենիկ",
    "Վարդենիս",
    "Վարսեր",
    "Վերին Գետաշեն",
    "Վերին Շորժա",
    "Տորֆավան",
    "Տրետուք",
    "Փամբակ",
    "Փոքր Մասրիկ"
  ],
  "Լոռի": [
    "Ագարակ",
    "Ազնվաձոր",
    "Աթան",
    "Ալավերդի",
    "Ախթալա",
    "Ակներ",
    "Ահնիձոր",
    "Ամոջ",
    "Ամրակից",
    "Այգեհատ",
    "Անտառամուտ",
    "Անտառաշեն",
    "Ապավեն",
    "Առողջարանին կից",
    "Արդվի",
    "Արծնի",
    "Արմանիս",
    "Արջուտ",
    "Արջուտ կայարանին կից",
    "Արևածագ",
    "Արևաշող",
    "Աքորի",
    "Բազում",
    "Բենդիկ",
    "Բլագոդարնոյե",
    "Բովաձոր",
    "Գարգառ",
    "Գեղասար",
    "Գետավան",
    "Գյուլագարակ",
    "Գոգավան",
    "Գոգարան",
    "Գուգարք",
    "Գուշար",
    "Դաշտադեմ",
    "Դարպաս",
    "Դեբետ",
    "Դսեղ",
    "Եղեգնուտ",
    "Թեղուտ",
    "Թումանյան",
    "Ժամատուն",
    "Լեջան",
    "Լեռնահովիտ",
    "Լեռնանցք",
    "Լեռնապատ",
    "Լեռնավան",
    "Լերմոնտովո",
    "Լոռի Բերդ",
    "Լորուտ",
    "Խնկոյան",
    "Ծաթեր",
    "Ծաղկաբեր",
    "Ծաղկաշատ",
    "Կաթնաղբյուր",
    "Կաթնաջուր",
    "Կաթնառատ",
    "Կաճաճկուտ",
    "Կարմիր Աղեկ",
    "Կողես",
    "Կուրթան",
    "Կրուգլայա շիշկա",
    "Հագվի",
    "Հալավար",
    "Հաղպատ",
    "Հայդարլի",
    "Հարթագյուղ",
    "Հոբարձի",
    "Հովնանաձոր",
    "Ձյունաշող",
    "Ձորագետ",
    "Ձորագյուղ",
    "Ձորամուտ",
    "Ղուրսալի",
    "Ճոճկան",
    "Մարգահովիտ",
    "Մարց",
    "Մեդովկա",
    "Մեծ Այրում",
    "Մեծ Պառնի",
    "Մեծավան",
    "Մեղվահովիտ",
    "Միխայելովկա",
    "Մղարթ",
    "Յաղդան",
    "Նեղոց",
    "Նովոսելցովո",
    "Նոր Խաչակապ",
    "Նորամուտ",
    "Նորաշեն",
    "Շահումյան",
    "Շամլուղ",
    "Շամուտ",
    "Շենավան",
    "Շիրակամուտ",
    "Շնող",
    "Ուռուտ",
    "Ուրասար",
    "Չկալով",
    "Պաղաղբյուր",
    "Պետրովկա",
    "Պուշկինո",
    "Պրիվոլնոյե",
    "Ջիլիզա",
    "Ջրաշեն",
    "Սարալանջ",
    "Սարահարթ",
    "Սարամեջ",
    "Սարատովկա",
    "Սարչապետ",
    "Սպիտակ",
    "Սվերդլով",
    "Ստեփանավան",
    "Վահագնաձոր",
    "Վահագնի",
    "Վանաձոր",
    "Վարդաբլուր",
    "Տաշիր",
    "Փամբակ",
    "Փամբակ կայարանին կից",
    "Փոքր Այրում",
    "Քարաբերդ",
    "Քարաձոր",
    "Քարինջ",
    "Քարկոփ",
    "Քոբեր կայարան",
    "Օձուն",
    "Ֆիոլետովո"
  ],
  "Կոտայք": [
    "Աբովյան",
    "Ալափարս",
    "Ակունք",
    "Աղավնաձոր",
    "Առինջ",
    "Արագյուղ",
    "Արամուս",
    "Արգել",
    "Արզական",
    "Արզնի",
    "Արտավազ",
    "Բալահովիտ",
    "Բյուրեղավան",
    "Բուժական",
    "Բջնի",
    "Գառնի",
    "Գեղադիր",
    "Գեղաշեն",
    "Գեղարդ",
    "Գետամեջ",
    "Գետարգել",
    "Գողթ",
    "Գոռգոչ",
    "Եղվարդ",
    "Զառ",
    "Զովաշեն",
    "Զովունի",
    "Զովք",
    "Զորավան",
    "Թեղենիք",
    "Լեռնանիստ",
    "Ծաղկաձոր",
    "Կաթնաղբյուր",
    "Կամարիս",
    "Կապուտան",
    "Կարենիս",
    "Կոտայք",
    "Հանքավան",
    "Հատիս",
    "Հացավան",
    "Հրազդան",
    "Ձորաղբյուր",
    "Մայակովսկի",
    "Մարմարիկ",
    "Մեղրաձոր",
    "Մրգաշեն",
    "Նոր Արտամետ",
    "Նոր Գեղի",
    "Նոր Երզնկա",
    "Նոր Հաճն",
    "Նոր գյուղ",
    "Նուռնուս",
    "Ողջաբերդ",
    "Չարենցավան",
    "Պռոշյան",
    "Պտղնի",
    "Ջրաբեր",
    "Ջրառատ",
    "Ջրվեժ",
    "Սարալանջ",
    "Սոլակ",
    "Սևաբերդ",
    "Վերին Պտղնի",
    "Փյունիկ",
    "Քաղսի",
    "Քանաքեռավան",
    "Քասախ",
    "Քարաշամբ",
    "Ֆանտան"
  ],
  "Շիրակ": [
    "Ազատան",
    "Ալվար",
    "Ախուրիկ",
    "Ախուրյան",
    "Ախուրյան կայարան",
    "Աղին",
    "Աղին կայարան",
    "Աղվորիկ",
    "Ամասիա",
    "Այգաբաց",
    "Անիավան",
    "Անիպեմզա",
    "Անուշավան",
    "Աշոցք",
    "Առափի",
    "Արավետ",
    "Արդենիս",
    "Արեգնադեմ",
    "Արթիկ",
    "Արփենի",
    "Արևիկ",
    "Արևշատ",
    "Բագրավան",
    "Բայանդուր",
    "Բանդիվան",
    "Բաշգյուղ",
    "Բասեն",
    "Բավրա",
    "Բարձրաշեն",
    "Բենիամին",
    "Բերդաշեն",
    "Բյուրակն",
    "Գառնառիճ",
    "Գեղանիստ",
    "Գետափ",
    "Գետք",
    "Գյումրի",
    "Գոգհովիտ",
    "Գուսանագյուղ",
    "Գտաշեն",
    "Դարիկ",
    "Եղնաջուր",
    "Երազգավորս",
    "Երիզակ",
    "Զարիշատ",
    "Զորակերտ",
    "Զույգաղբյուր",
    "Թավշուտ",
    "Թորոսգյուղ",
    "Իսահակյան",
    "Լանջիկ",
    "Լեռնագյուղ",
    "Լեռնակերտ",
    "Լեռնուտ",
    "Լորասար",
    "Լուսակերտ",
    "Լուսաղբյուր",
    "Ծաղկուտ",
    "Կամխուտ",
    "Կամո",
    "Կապս",
    "Կառնուտ",
    "Կարմրավան",
    "Կարմրաքար",
    "Կաքավասար",
    "Կրաշեն",
    "Կրասար",
    "Հայկաձոր",
    "Հայկասար",
    "Հայկավան",
    "Հայրենյաց",
    "Հառիճ",
    "Հարթաշեն",
    "Հացիկ",
    "Հացիկավան",
    "Հողմիկ",
    "Հոռոմ",
    "Հովիտ",
    "Հովունի",
    "Հովտաշեն",
    "Հովտուն",
    "Ձիթհանքով",
    "Ձորակապ",
    "Ձորաշեն",
    "Ղազանչի",
    "Ղարիբջանյան",
    "Մայիսյան",
    "Մարալիկ",
    "Մարմաշեն",
    "Մեծ Մանթաշ",
    "Մեծ Սարիար",
    "Մեծ Սեպասար",
    "Մեղրաշատ",
    "Մեղրաշեն",
    "Նահապետավան",
    "Նոր Կյանք",
    "Նորշեն",
    "Շաղիկ",
    "Շիրակ",
    "Շիրակավան",
    "Ողջի",
    "Ոսկեհասկ",
    "Պաղակն",
    "Պեմզաշեն",
    "Ջաջուռ",
    "Ջաջուռավան",
    "Ջրաձոր",
    "Ջրառատ",
    "Ջրափի",
    "Սալուտ",
    "Սառնաղբյուր",
    "Սարագյուղ",
    "Սարալանջ",
    "Սարակապ",
    "Սարապատ",
    "Սարատակ",
    "Սիզավետ",
    "Սպանդարյան",
    "Վահրամաբերդ",
    "Վարդաղբյուր",
    "Վարդաքար",
    "Տուֆաշեն",
    "Ցողամարգ",
    "Փանիկ",
    "Փոքր Մանթաշ",
    "Փոքր Սարիար",
    "Փոքր Սեպասար",
    "Փոքրաշեն",
    "Քարաբերդ",
    "Քեթի"
  ],
  "Սյունիք": [
    "Ագարակ",
    "Ալվանք",
    "Ախլաթյան",
    "Ակներ",
    "Աղբուլլաղ",
    "Աղիտու",
    "Աղվանի",
    "Աճանան",
    "Այգեձոր",
    "Անգեղակոթ",
    "Անտառաշատ",
    "Աշոտավան",
    "Աջաբաջ",
    "Առաջաձոր",
    "Արավուս",
    "Արծվանիկ",
    "Արևիս",
    "Բալաք",
    "Բարգուշատ",
    "Բարձրավան",
    "Բնունիս",
    "Բռնակոթ",
    "Գեղանուշ",
    "Գեղավանք",
    "Գեղի",
    "Գետաթաղ",
    "Գետիշեն",
    "Գոմարան",
    "Գորայք",
    "Գորիս",
    "Գուդեմնիս",
    "Դաստակերտ",
    "Դավիթ Բեկ",
    "Դարբաս",
    "Դիցմայրի",
    "Եղեգ",
    "Եղվարդ",
    "Թանահատ",
    "Թասիկ",
    "Թխկուտ",
    "Իշխանասար",
    "Լեհվազ",
    "Լեռնաձոր",
    "Լիճք",
    "Լծեն",
    "Լոր",
    "Խդրանց",
    "Խնածախ",
    "Խնձորեսկ",
    "Խոզնավար",
    "Խոտ",
    "Խորձոր",
    "Ծավ",
    "Ծղուկ",
    "Կաղնուտ",
    "Կապան",
    "Կավճուտ",
    "Կարդ",
    "Կարճևան",
    "Կիցք",
    "Կոռնիձոր",
    "Կուրիս",
    "Հալիձոր",
    "Հարթաշեն",
    "Հարժիս",
    "Հացավան",
    "Ձորակ",
    "Ձորաստան",
    "Ճակատեն",
    "Մեղրի",
    "Մուսալլամ",
    "Մուցք",
    "Ներքին Գիրաթաղ",
    "Ներքին Խնձորեսկ",
    "Ներքին Խոտանան",
    "Ներքին Հանդ",
    "Նժդեհ",
    "Նոր Աստղաբերդ",
    "Նորաշենիկ",
    "Նորավան",
    "Նռնաձոր",
    "Շաղատ",
    "Շամբ",
    "Շաքի",
    "Շենաթաղ",
    "Շիկահող",
    "Շինուհայր",
    "Շիշկերտ",
    "Շուռնուխ",
    "Շվանիձոր",
    "Շրվենանց",
    "Ոչեթի",
    "Որոտան",
    "Որոտնավան",
    "Ուժանիս",
    "Ույծ",
    "Չափնի",
    "Սալվարդ",
    "Սառնակունք",
    "Սզնակ",
    "Սիսիան",
    "Սյունիք",
    "Սպանդարյան",
    "Սվարանց",
    "Սրաշեն",
    "Սևաքար",
    "Վահրավար",
    "Վաղատին",
    "Վաղատուր",
    "Վանանդ",
    "Վանեք",
    "Վարդանիձոր",
    "Վարդավանք",
    "Վերին Գեղավանք",
    "Վերին Գիրաթաղ",
    "Վերին Խոտանան",
    "Վերիշեն",
    "Տաթև",
    "Տանձավեր",
    "Տանձատափ",
    "Տաշտուն",
    "Տավրուս",
    "Տեղ",
    "Տոլորս",
    "Տորունիք",
    "Ցղունի",
    "Քաշունի",
    "Քաջարան",
    "Քարահունջ",
    "Քարաշեն",
    "Քարուտ",
    "Օխտար"
  ],
  "Վայոց Ձոր": [
    "Ագարակաձոր",
    "Ազատեկ",
    "Ախտա",
    "Աղավնաձոր",
    "Աղնջաձոր",
    "Ամաղու",
    "Արատես",
    "Արենի",
    "Արին",
    "Արտաբույնք",
    "Արտավան",
    "Արփի",
    "Բարձրունի",
    "Գետափ",
    "Գետիկվանք",
    "Գլաձոր",
    "Գնդևազ",
    "Գնիշիկ",
    "Գողթանիկ",
    "Գոմք",
    "Ելփին",
    "Եղեգիս",
    "Եղեգնաձոր",
    "Զառիթափ",
    "Զեդեա",
    "Թառաթումբ",
    "Խաչիկ",
    "Խնձորուտ",
    "Կալասար",
    "Կապույտ",
    "Կարմրաշեն",
    "Կեչուտ",
    "Հերհեր",
    "Հերմոն",
    "Հորադիս",
    "Հորբատեղ",
    "Հորս",
    "Մալիշկա",
    "Մարտիրոս",
    "Մոզրով",
    "Նոր Ազնաբերդ",
    "Շատին",
    "Ուղեձոր",
    "Չիվա",
    "Ջերմուկ",
    "Ռինդ",
    "Սալլի",
    "Սարավան",
    "Սերս",
    "Սևաժայռ",
    "Վայք",
    "Վարդահովիտ",
    "Վերնաշեն",
    "Փոռ",
    "Քարագլուխ"
  ],
  "Տավուշ": [
    "Ազատամուտ",
    "Ակնաղբյուր",
    "Աղավնավանք",
    "Աճարկուտ",
    "Այգեհովիտ",
    "Այգեձոր",
    "Այգեպար",
    "Այրում",
    "Աչաջուր",
    "Ասկիպար",
    "Արծվաբերդ",
    "Արճիս",
    "Բագրատաշեն",
    "Բաղանիս",
    "Բարեկամավան",
    "Բարխուդարլու",
    "Բերդ",
    "Բերդավան",
    "Բերքաբեր",
    "Գանձաքար",
    "Գեղատափ",
    "Գետահովիտ",
    "Գոշ",
    "Դեբեդավան",
    "Դեղձավան",
    "Դիլիջան",
    "Դիտավան",
    "Դովեղ",
    "Ենոքավան",
    "Զորական",
    "Թեղուտ",
    "Իծաքար",
    "Իջևան",
    "Լճկաձոր",
    "Լուսահովիտ",
    "Լուսաձոր",
    "Խաշթառակ",
    "Խաչարձան",
    "Ծաղկավան (Իջևան)",
    "Ծաղկավան (Տավուշ)",
    "Կիրանց",
    "Կոթի",
    "Կողբ",
    "Հաղարծին",
    "Հաղթանակ",
    "Հովք",
    "Ճերմակավան",
    "Մոսեսգեղ",
    "Նավուր",
    "Ներքին Կարմիր աղբյուր",
    "Նոյեմբերյան",
    "Նորաշեն",
    "Ոսկեպար",
    "Ոսկևան",
    "Չինարի",
    "Չինչին",
    "Չորաթան",
    "Պառավաքար",
    "Պտղավան",
    "Ջուջևան",
    "Սարիգյուղ",
    "Սևքար",
    "Վազաշեն",
    "Վարագավան",
    "Վերին Կարմիր աղբյուր",
    "Տավուշ"
  ]
};
